/** @jsx isolateComponent */

import { css } from '@emotion/core';

import { isolateComponent } from '@zapier/common-utils';
import { Colors, Text } from '@zapier/design-system';

type PlanActionButtonSubstituteProps = {
  /** The text to show. */
  text: string;
};

const rootStyles = css`
  background: ${Colors.white};
  border-radius: 10px;
  padding: 15px 20px;
`;

/**
 * A component that mimics the appearance of a `PlanActionButton` but doesn't have button functionality.
 */
export const PlanActionButtonSubstitute = ({
  text,
}: PlanActionButtonSubstituteProps) => (
  <div css={rootStyles}>
    <Text color="grey700" tag="p" textAlign="center" type="altText900">
      {text}
    </Text>
  </div>
);
